<template>
<div>
 <div ref="spinner" id="html-spinner"></div>
 </div>
</template>

<script>
export default {
  name: 'loader-icon',
  props: ['color'],
  data () {
    return {
      dialog: false,
      minutes: null,
      isUploaded: false,
      isTranscriptsLoaded: false
    }
  },
  computed: {
    displayColor () {
      return this.color || 'gray'
    },
    style () {
      return `border:2px solid ${this.displayColor}`
    }
  },
  mounted () {
    const me = this
    me.$refs.spinner.setAttribute('style', me.style)
  }
}
</script>

<style scoped>

svg{
  width: 100px;
  height: 100px;
  margin: 20px;
  display:inline-block;
}

#html-spinner{
  width:70px;
  height:70px;
  border-top:4px solid transparent!important;
  border-radius:50%;
  margin: inherit!important;
}

#html-spinner, #svg-spinner{
  -webkit-transition-property: -webkit-transform;
  -webkit-transition-duration: 0.6s;
  -webkit-animation-name: rotate;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;

  -moz-transition-property: -moz-transform;
  -moz-animation-name: rotate;
  -moz-animation-duration: 0.6s;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: linear;

  transition-property: transform;
  animation-name: rotate;
  animation-duration: 0.6s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@-webkit-keyframes rotate {
    from {-webkit-transform: rotate(0deg);}
    to {-webkit-transform: rotate(360deg);}
}

@-moz-keyframes rotate {
    from {-moz-transform: rotate(0deg);}
    to {-moz-transform: rotate(360deg);}
}

@keyframes rotate {
    from {transform: rotate(0deg);}
    to {transform: rotate(360deg);}
}

</style>
